"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RetweetIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.544 1l3.469 3.58a.991.991 0 01.02 1.338.85.85 0 01-1.257.022L4.53 4.654v8.08h4.158c.491 0 .89.425.89.948 0 .523-.399.947-.89.947H4.1c-.717 0-1.347-.608-1.347-1.42V4.453L1.507 5.739A.85.85 0 01.25 5.718a.991.991 0 01.02-1.34L3.544 1zm2.879 1.318c0-.523.398-.947.889-.947H11.9c.717 0 1.347.608 1.347 1.42v8.755l1.246-1.285a.85.85 0 011.256.021.991.991 0 01-.02 1.34L12.457 15l-3.469-3.58a.991.991 0 01-.02-1.338.85.85 0 011.257-.022l1.245 1.286v-8.08H7.313c-.491 0-.89-.425-.89-.948z",
    clipRule: "evenodd"
  })))
});
RetweetIcon.displayName = 'RetweetIcon';
var _default = exports.default = RetweetIcon;